import Fluxible from 'fluxible';
import App from './components/App';

import RouteStore from './stores/Route';
import AppStore from './stores/App';
import UserStore from './stores/User';

export default new Fluxible({
  component: App,

  stores: [
    RouteStore,
    AppStore,
    UserStore,
  ],
});



// WEBPACK FOOTER //
// ./src/app/index.js